import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function TradeDownIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20 10C20.5523 10 21 10.4477 21 11V16C21 16.5523 20.5523 17 20 17H15C14.4477 17 14 16.5523 14 16C14 15.4477 14.4477 15 15 15H19V11C19 10.4477 19.4477 10 20 10Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.29289 7.29289C3.68342 6.90237 4.31658 6.90237 4.70711 7.29289L9 11.5858L12.2929 8.29289C12.6834 7.90237 13.3166 7.90237 13.7071 8.29289L20.7071 15.2929C21.0976 15.6834 21.0976 16.3166 20.7071 16.7071C20.3166 17.0976 19.6834 17.0976 19.2929 16.7071L13 10.4142L9.70711 13.7071C9.31658 14.0976 8.68342 14.0976 8.29289 13.7071L3.29289 8.70711C2.90237 8.31658 2.90237 7.68342 3.29289 7.29289Z"
				fill="currentColor"
			/>
		</svg>
	);
}

TradeDownIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default TradeDownIcon;
